import { HttpClient } from "core/http";

const ApiService = () => {
  let httpClient = HttpClient();
  let apiRootUrl = "/v1/tax-invoices";

  const getTaxInvoices = (id) => httpClient.get(`${apiRootUrl}/${id}`);

  const downloadPdf = (id) =>
    httpClient.get(`${apiRootUrl}/${id}/download`, {
      responseType: "blob",
    });

  return {
    getTaxInvoices,
    downloadPdf,
  };
};

export default ApiService;
